import { NavigateFunction } from "react-router";

export const navigation: {navigate: NavigateFunction | null } = {
    navigate: null
};